// extracted by mini-css-extract-plugin
export default {"root":"MMPyCM","followButtonTag":"x7OJl5","followButton":"G5sp7C","icon":"X9lI5j"};